(function () {
  var authoredButtonAttribute = 'data-idealhouse-authored-button';
  var authoredButtonSelector = '[' + authoredButtonAttribute + ']';
  var sdkRequested = false;
  var buttonObserver = null;

  function normalizeImageCrop(data, imageData, effects) {
    var sourceWidth = Number(imageData && imageData.naturalWidth);
    var sourceHeight = Number(imageData && imageData.naturalHeight);
    var x = Number(data && data.x);
    var y = Number(data && data.y);
    var width = Number(data && data.width);
    var height = Number(data && data.height);
    if (![sourceWidth, sourceHeight, x, y, width, height].every(Number.isFinite)
      || sourceWidth <= 0 || sourceHeight <= 0 || width <= 0 || height <= 0) return undefined;

    var left = Math.max(0, Math.min(1, x / sourceWidth));
    var top = Math.max(0, Math.min(1, y / sourceHeight));
    var right = Math.max(left, Math.min(1, (x + width) / sourceWidth));
    var bottom = Math.max(top, Math.min(1, (y + height) / sourceHeight));
    if (right <= left || bottom <= top) return undefined;

    return {
      version: 1,
      space: 'normalized-source',
      x: left,
      y: top,
      width: right - left,
      height: bottom - top,
      flipX: Boolean(effects && effects.flipX),
      grayscale: Boolean(effects && effects.grayscale),
      sourceWidth: sourceWidth,
      sourceHeight: sourceHeight
    };
  }

  function isValidImageCrop(crop) {
    return crop
      && crop.version === 1
      && crop.space === 'normalized-source'
      && [crop.x, crop.y, crop.width, crop.height, crop.sourceWidth, crop.sourceHeight].every(Number.isFinite)
      && crop.x >= 0 && crop.y >= 0
      && crop.width > 0 && crop.height > 0
      && crop.x + crop.width <= 1.000001
      && crop.y + crop.height <= 1.000001
      && crop.sourceWidth > 0 && crop.sourceHeight > 0;
  }

  function syncCustomSizeButton(button, dimensions, imageCrop) {
    if (!button) return false;

    var width = Number(dimensions && dimensions.width);
    var height = Number(dimensions && dimensions.height);
    var unit = dimensions && dimensions.unit;
    var validUnit = unit === 'cm' || unit === 'in' || unit === 'ft';
    var valid = width > 0 && height > 0 && Number.isFinite(width) && Number.isFinite(height)
      && validUnit && isValidImageCrop(imageCrop);

    if (!valid) {
      button.hidden = true;
      if (button.hasAttribute(authoredButtonAttribute)) button.removeAttribute(authoredButtonAttribute);
      button.removeAttribute('data-product-width');
      button.removeAttribute('data-product-height');
      button.removeAttribute('data-product-size-unit');
      button.removeAttribute('data-product-size-mode');
      button.removeAttribute('data-product-image-crop');
      return false;
    }

    button.setAttribute('data-product-width', width);
    button.setAttribute('data-product-height', height);
    button.setAttribute('data-product-size-unit', unit);
    button.setAttribute('data-product-size-mode', 'stretch');
    button.setAttribute('data-product-image-crop', JSON.stringify(imageCrop));
    button.hidden = false;
    if (!button.hasAttribute(authoredButtonAttribute)) button.setAttribute(authoredButtonAttribute, '');
    return true;
  }

  function loadSdk() {
    if (sdkRequested) return;
    sdkRequested = true;

    var script = document.createElement('script');
    script.src = 'https://sdk.ideal.house/sdk.js';
    script.async = true;
    script.dataset.shopId = '875306665329561600';
    script.dataset.publishableKey = 'pk_heBl9WtNn8gy4TNE6JbRAPIGX4RYC1ndbypeLKNPcEk';
    script.dataset.floatMapPlacementMode = 'fit-wall-height';
    script.dataset.authoredButtonSelector = authoredButtonSelector;
    script.dataset.locale = (document.documentElement.lang || 'en').toLowerCase();
    document.head.appendChild(script);

    if (buttonObserver) buttonObserver.disconnect();
  }

  function containsAuthoredButton(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(authoredButtonSelector)) return true;
    return Boolean(node.querySelector && node.querySelector(authoredButtonSelector));
  }

  function start() {
    if (document.querySelector(authoredButtonSelector)) {
      loadSdk();
      return;
    }

    if (typeof MutationObserver === 'undefined') return;
    buttonObserver = new MutationObserver(function (mutations) {
      var found = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, containsAuthoredButton);
      });
      if (found) loadSdk();
    });
    buttonObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.EverIdealhouseRoomVisualizer = {
    normalizeImageCrop: normalizeImageCrop,
    syncCustomSizeButton: syncCustomSizeButton
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
